import { apiRequest } from "./apiClient";

/**
 * The reactivation call list. `includeRecent` also returns patients inside the
 * clinic's cooldown, which the list hides by default.
 */
export async function fetchReactivationList(clinicId, { includeRecent = false } = {}) {
  const params = new URLSearchParams();
  if (clinicId) params.set("clinic_id", clinicId);
  if (includeRecent) params.set("include_recent", "true");
  const query = params.toString();
  const response = await apiRequest({
    method: "GET",
    endpoint: `/scheduling/reactivation-list${query ? `?${query}` : ""}`,
  });
  return response?.data ?? response ?? {};
}
